import React from 'react';
import Icons from '../../assets/Icons';
import { useTheme } from './Theme';

const ThemeLogo = ({ icon, className, style, ...props }) => {
  const [theme] = useTheme();
  const IconSVG = Icons[theme]?.[icon];
  return <IconSVG className={className} style={style} {...props} />;
};

export default ThemeLogo;
